export default __webpack_public_path__ + "static/omg-seo-e09c5c093a0d35229b454863f939a58e.jpeg";